import { render } from "./HeroiconsOutlineNewspaper.vue?vue&type=template&id=6051826e"
const script = {}

import exportComponent from "/var/app/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineNewspaper.vue"]])

export default __exports__